export const IMGS = {
  hero: [
    '/images/hero/hero-image-1.jpeg',
    '/images/hero/hero-image-2.jpeg',
    '/images/hero/hero-image-3.jpeg',
  ],
  about: '/images/about-us.jpeg',
  cuisine: [
    '/images/cuisine/cuisine-south.jpeg',
    '/images/cuisine/cuisine-north.jpeg',
    '/images/cuisine/cuisine-continental.jpeg',
    '/images/cuisine/cuisine-asian-fusion.jpeg',
    '/images/cuisine/cuisine-mediterranean.jpeg',
    '/images/cuisine/cuisine-desserts.jpeg',
    '/images/cuisine/cuisine-beverages.jpeg',
  ],
  gallery: [
    '/images/gallery/gallery-0.jpeg',
    '/images/gallery/gallery-1.jpeg',
    '/images/gallery/gallery-3.jpeg',
    '/images/gallery/gallery-4.jpeg',
    '/images/gallery/gallery-5.jpeg',
    '/images/gallery/gallery-6.jpeg',
    '/images/gallery/gallery-7.jpeg',
    '/images/gallery/gallery-8.jpeg',
  ],
  services: [
    '/images/services/services-0.jpeg',
    '/images/services/services-1.jpeg',
    '/images/services/services-3.jpeg',
    '/images/services/services-4.jpeg',
    '/images/services/services-5.jpeg',
    '/images/services/services-6.jpeg',
  ],
  banner:      '/images/banner-1.jpeg',
  testimonial: [
    '/images/reviews/vinay-review.png',
  ],
};